import React from "react"
import PropTypes from 'prop-types'

const Sort = ({
  style     = {},
  fill      = "currentColor",
  width     = "100%",
  className = "sort",
  viewBox   = "0 0 100 100"
}) => (
  <svg
    width     = {width}
    style     = {style}
    viewBox   = {viewBox}
    xmlns     = "http://www.w3.org/2000/svg"
    className = {`svg-icon ${className || ""}`}
    fill      = {fill}
  >
    <g>
      <path d="M31.8,55l-5.4,5.4V27.6c0-2.8-2.2-5-5-5s-5,2.2-5,5v32.8L11,55c-2-2-5.1-2-7.1,0c-2,2-2,5.1,0,7.1L17.9,76     c1,1,2.3,1.5,3.5,1.5s2.6-0.5,3.5-1.5l13.9-13.9c2-1.9,2-5.1,0-7.1C36.9,53.1,33.7,53,31.8,55z"></path>
      <path d="M92.5,67.4H53.2c-2.8,0-5,2.2-5,5s2.2,5,5,5h39.3c2.8,0,5-2.2,5-5S95.3,67.4,92.5,67.4z"></path>
      <path d="M53.2,55h29.3c2.8,0,5-2.2,5-5s-2.2-5-5-5H53.2c-2.8,0-5,2.2-5,5S50.4,55,53.2,55z"></path>
      <path d="M53.2,32.6h19.4c2.8,0,5-2.2,5-5s-2.2-5-5-5H53.2c-2.8,0-5,2.2-5,5S50.4,32.6,53.2,32.6z"></path>
    </g>
  </svg>
   
)

Sort.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string
}

export default Sort
